import Base from 'app/models/base';
import CustomsItems from 'app/collections/customs_items';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('customs_infos'),
  rootKey: 'customs_info',

  nestedModels: {
    customs_items: CustomsItems,
  },

  attrsToJSON() {
    const json = Base.prototype.attrsToJSON.apply(this);

    if (!json.customs_items || json.customs_items.length === 0) {
      delete json.customs_items;
    }

    return json;
  },
});



// WEBPACK FOOTER //
// ./app/models/customs_info.js